import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { I18n, Status } from 'components';

import styles from '../styles.pcss';

const cx = classNames.bind(styles);

export const SuccessStatus = ({ id }) => (
  <Status className={[cx('message'), 'success']}>
    <I18n path="internet.messages.successRequest" vars={{ id }} />
  </Status>
);

SuccessStatus.propTypes = {
  id: PropTypes.number,
};
